/* tslint:disable */
/* eslint-disable */
// @ts-nocheck
/**
 * Audius API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateRewardCodeRequest
 */
export interface CreateRewardCodeRequest {
    /**
     * Base64-encoded Solana Ed25519 signature of the string "code"
     * @type {string}
     * @memberof CreateRewardCodeRequest
     */
    signature: string;
    /**
     * The coin mint address
     * @type {string}
     * @memberof CreateRewardCodeRequest
     */
    mint: string;
    /**
     * The reward amount (must be greater than 0)
     * @type {number}
     * @memberof CreateRewardCodeRequest
     */
    amount: number;
}

/**
 * Check if a given object implements the CreateRewardCodeRequest interface.
 */
export function instanceOfCreateRewardCodeRequest(value: object): value is CreateRewardCodeRequest {
    let isInstance = true;
    isInstance = isInstance && "signature" in value && value["signature"] !== undefined;
    isInstance = isInstance && "mint" in value && value["mint"] !== undefined;
    isInstance = isInstance && "amount" in value && value["amount"] !== undefined;

    return isInstance;
}

export function CreateRewardCodeRequestFromJSON(json: any): CreateRewardCodeRequest {
    return CreateRewardCodeRequestFromJSONTyped(json, false);
}

export function CreateRewardCodeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateRewardCodeRequest {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'signature': json['signature'],
        'mint': json['mint'],
        'amount': json['amount'],
    };
}

export function CreateRewardCodeRequestToJSON(value?: CreateRewardCodeRequest | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'signature': value.signature,
        'mint': value.mint,
        'amount': value.amount,
    };
}

